// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"tag-page-m__tag-wrapper__3iRDh","heading":"tag-page-m__heading__1A_WF","text-result":"tag-page-m__text-result__3qC5C","dfp":"tag-page-m__dfp__3rhah"};